export default "__VITE_ASSET__BRi9S7Wh__"